/**
 * @generated SignedSource<<5e50ed0fb0c0a1353315802d600f8bba>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly __typename: string;
      readonly connectorId?: string | null;
      readonly connectorProduct?: string | null;
      readonly connectorType?: string | null;
      readonly datasourceId?: string | null;
      readonly description: string;
      readonly id: string;
      readonly integrationId?: string | null;
      readonly issue?: {
        readonly webUrl: AGG$URL | null;
      } | null;
      readonly linkedEntities?: ReadonlyArray<{
        readonly id: string;
      }> | null;
      readonly linkedResults: ReadonlyArray<{
        readonly category: SearchLinkedResultCategory;
        readonly connectorType: string | null;
        readonly datasourceId?: string | null;
        readonly id: string;
      }> | null;
      readonly ownerId?: string | null;
      readonly providerId?: string | null;
      readonly repository?: {
        readonly scm: string | null;
      };
      readonly socialSignal?: {
        readonly signal: string | null;
      } | null;
      readonly type?: SearchResultType;
      readonly url?: string;
      readonly " $fragmentSpreads": FragmentRefs<"searchResult_AtlassianSearchPage">;
    } | null;
  }>;
  readonly errors: ReadonlyArray<{
    readonly integration: string | null;
    readonly product: string | null;
    readonly statusCode: number;
  }> | null;
  readonly pageInfo: {
    readonly endCursor: string | null;
    readonly hasNextPage: boolean;
  };
  readonly queryInfo: {
    readonly originalQuery: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"autoCorrection_AtlassianSearchPage">;
  } | null;
  readonly traceId: string | null;
  readonly " $fragmentType": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData";
};
export type searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$key = {
  readonly " $data"?: searchResults_AtlassianSearchPage_SearchResultsBody_connectionData$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchResults_AtlassianSearchPage_SearchResultsBody_connectionData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "condition": "includeDatasourceId",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "datasourceId"
    }
  ]
},
v2 = {
  "kind": "ScalarField",
  "name": "connectorType"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isassetsenabledrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCaseEmbeddedComments"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeCodeSearch"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeDatasourceId"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeFastJiraHydration"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeJiraLiteModeFields"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeMercuryAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePassionfruitAsk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includePositions"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeRisk"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeThirdPartyId"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchResults_AtlassianSearchPage_SearchResultsBody_connectionData",
  "selections": [
    {
      "concreteType": "SearchResultItemEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "__typename"
            },
            (v0/*: any*/),
            {
              "kind": "ScalarField",
              "name": "description"
            },
            {
              "concreteType": "SearchLinkedResult",
              "kind": "LinkedField",
              "name": "linkedResults",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "category"
                },
                (v2/*: any*/)
              ]
            },
            {
              "args": [
                {
                  "kind": "Variable",
                  "name": "includeAssets",
                  "variableName": "__relay_internal__pv__isassetsenabledrelayprovider"
                },
                {
                  "kind": "Variable",
                  "name": "includeCaseEmbeddedComments",
                  "variableName": "includeCaseEmbeddedComments"
                },
                {
                  "kind": "Variable",
                  "name": "includeCodeSearch",
                  "variableName": "includeCodeSearch"
                },
                {
                  "kind": "Variable",
                  "name": "includeDatasourceId",
                  "variableName": "includeDatasourceId"
                },
                {
                  "kind": "Variable",
                  "name": "includeFastJiraHydration",
                  "variableName": "includeFastJiraHydration"
                },
                {
                  "kind": "Variable",
                  "name": "includeJiraLiteModeFields",
                  "variableName": "includeJiraLiteModeFields"
                },
                {
                  "kind": "Variable",
                  "name": "includeMercuryAsk",
                  "variableName": "includeMercuryAsk"
                },
                {
                  "kind": "Variable",
                  "name": "includeNavBoostScore",
                  "variableName": "includeNavBoostScore"
                },
                {
                  "kind": "Variable",
                  "name": "includePassionfruitAsk",
                  "variableName": "includePassionfruitAsk"
                },
                {
                  "kind": "Variable",
                  "name": "includePositions",
                  "variableName": "includePositions"
                },
                {
                  "kind": "Variable",
                  "name": "includeRisk",
                  "variableName": "includeRisk"
                },
                {
                  "kind": "Variable",
                  "name": "includeThirdPartyId",
                  "variableName": "includeThirdPartyId"
                }
              ],
              "kind": "FragmentSpread",
              "name": "searchResult_AtlassianSearchPage"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                (v1/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "providerId"
                },
                {
                  "kind": "ScalarField",
                  "name": "integrationId"
                },
                (v2/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "connectorId"
                },
                {
                  "kind": "ScalarField",
                  "name": "connectorProduct"
                },
                {
                  "concreteType": "SearchResultGraphDocument",
                  "kind": "LinkedField",
                  "name": "linkedEntities",
                  "plural": true,
                  "selections": [
                    (v0/*: any*/)
                  ]
                }
              ],
              "type": "SearchResultGraphDocument"
            },
            {
              "condition": "includeCodeSearch",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "concreteType": "SearchResultCodeRepository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "scm"
                        }
                      ]
                    }
                  ],
                  "type": "SearchResultGraphCode"
                }
              ]
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "ownerId"
                }
              ],
              "type": "SearchResultCompassComponent"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "url"
                },
                {
                  "concreteType": "JiraIssue",
                  "kind": "LinkedField",
                  "name": "issue",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "webUrl"
                    }
                  ]
                }
              ],
              "type": "SearchResultJiraIssue"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "type"
                },
                {
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "tenantId",
                      "variableName": "tenantId"
                    }
                  ],
                  "concreteType": "SocialSignalSearch",
                  "kind": "LinkedField",
                  "name": "socialSignal",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "signal"
                    }
                  ]
                }
              ],
              "type": "SearchConfluencePageBlogAttachment"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchQueryInfo",
      "kind": "LinkedField",
      "name": "queryInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "originalQuery"
        },
        {
          "kind": "FragmentSpread",
          "name": "autoCorrection_AtlassianSearchPage"
        }
      ]
    },
    {
      "concreteType": "PageInfo",
      "kind": "LinkedField",
      "name": "pageInfo",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "endCursor"
        },
        {
          "kind": "ScalarField",
          "name": "hasNextPage"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "traceId"
    },
    {
      "concreteType": "SearchError",
      "kind": "LinkedField",
      "name": "errors",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "statusCode"
        },
        {
          "kind": "ScalarField",
          "name": "product"
        },
        {
          "kind": "ScalarField",
          "name": "integration"
        }
      ]
    }
  ],
  "type": "SearchItemConnection"
};
})();

(node as any).hash = "8e68dbb4e2847a49c0909a34245ef145";

export default node;
